import { PaymentElement } from '@stripe/react-stripe-js';
import Column from '@sdk/components/ui/spacing/Column';
import useConfig from '@sdk/config/useConfig';

import { useBillingInfo } from '@web/account/billing/BillingInfoContext';

import { PAYMENT_OPTIONS } from './creditCardForm.consts';

type Props = {
  isBillingAddressFormActive?: boolean;
};

const CreditCardForm = ({ isBillingAddressFormActive }: Props) => {
  const { FEATURE_FLAGS } = useConfig();
  const { billingInfo } = useBillingInfo();
  // full name and address are required:
  // - if billingAddress form is on the page, Stripe Elements uses this data automatically
  // - if form is not on the page, but billingAddress was filled before we need to pass it in createPaymentMethod
  // - if form is not on the page and billingAddress is not filled, additional fields need to be displayed on credit card form
  const paymentProps =
    FEATURE_FLAGS.TAX_CALCULATIONS_ENABLED &&
    (billingInfo.billingAddress || isBillingAddressFormActive)
      ? PAYMENT_OPTIONS
      : {};

  return (
    <Column mTop={10}>
      <PaymentElement {...paymentProps} />
    </Column>
  );
};

export default CreditCardForm;
